<template>
  <div class="giftList">
    <el-form ref="tableForm" :model="{ tableData: value }" :rules="formRules">
      <el-table :data="value" style="width: 100%" size="mini">
        <el-table-column
          prop="giftsCode"
          label="赠品编码"
          width="200"
          :render-header="renderHeade"
        >
          <template slot-scope="{ row, $index }">
            <el-form-item
              :prop="'tableData.' + $index + '.giftsCode'"
              :rules="formRules.giftsCode"
            >
              <el-autocomplete
                v-model="row.giftsCode"
                style="width: 175px"
                :fetch-suggestions="querySearch"
                placeholder="请输入商品编码"
                :trigger-on-focus="false"
                :maxlength="40"
                show-word-limit
                @select="value => handleSelectGiftsCode(value, row)"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="giftsName"
          label="赠品名称"
          min-width="180"
          :render-header="renderHeade"
        >
          <template slot-scope="{ row, $index }">
            <el-form-item
              :prop="'tableData.' + $index + '.giftsName'"
              :rules="formRules.giftsName"
            >
              <el-input
                v-model="row.giftsName"
                style="width: 100%"
                placeholder="请输入赠品名称"
                maxlength="30"
                show-word-limit
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="giftsNum"
          label="赠品数量"
          width="120"
          :render-header="renderHeade"
        >
          <template slot-scope="{ row, $index }">
            <el-form-item
              :prop="'tableData.' + $index + '.giftsNum'"
              :rules="formRules.giftsNum"
            >
              <el-input-number
                v-model="row.giftsNum"
                placeholder="请输入赠品数量"
                :min="1"
                :max="8"
                :step-strictly="true"
                :controls="false"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="giftsImgList"
          label="赠品图片(最多上传7张图片)"
          width="400"
          :render-header="renderHeade"
        >
          <template slot-scope="{ row, $index }">
            <el-form-item
              :prop="'tableData.' + $index + '.giftsImgList'"
              :rules="formRules.giftsImgList"
            >
              <ImageUpload
                v-model="row.giftsImgList"
                :limit="7"
                :tips="['最多上传7张图片，图片不能大于5M，格式为jpg,png,jpeg']"
                @change="value => getGiftsListChange(row, value)"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作" width="80">
          <template slot-scope="{ $index }">
            <el-button type="text" @click="handleDelete($index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-button
      class="addBtn"
      size="mini"
      plain
      type="primary"
      @click="handleAdd"
      >新增赠品</el-button
    >
  </div>
</template>

<script>
import { materialGifts } from '@/api/shop'
import ImageUpload from './ImageUpload'
const objData = {
  giftsCode: '',
  giftsName: '',
  giftsNum: '',
  giftsImgList: [],
  giftsType: 1
}
export default {
  components: { ImageUpload },
  props: {
    value: {
      type: Array,
      default: () => [{ ...objData }]
    }
  },
  data() {
    return {
      formRules: {
        giftsCode: [
          { required: true, message: '商品编码为必填项', trigger: 'input' }
        ],
        giftsName: [
          { required: true, message: '赠品名称为必填项', trigger: 'input' }
        ],
        giftsNum: [
          { required: true, message: '赠品数量为必填项', trigger: 'input' }
        ],
        giftsImgList: [
          {
            type: 'array',
            required: true,
            min: 1,
            message: '赠品图片为必填项，至少上传一张图片',
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    if (!this.value?.length || this.value[0]?.giftsImgList?.length === 0) {
      this.$emit('input', [{ ...objData }])
    }
  },
  methods: {
    renderHeade(h, { column }) {
      return h('div', [
        // 容器节点（span）
        // 红色*符号（子节点1）
        h(
          'span',
          {
            style: {
              color: 'red', // 红色
              marginRight: '4px' // 与文字间隔
            }
          },
          '*'
        ),
        // 原表头文字（子节点2）
        h('span', column.label)
      ])
    },
    async validateAll() {
      const bol = this.value.find(
        item =>
          !item?.giftsImgList ||
          (item?.giftsImgList && !item?.giftsImgList?.length)
      )
      if (bol) {
        this.$message.error('赠品图片为必填项，至少上传一张图片')
      }
      await this.$refs.tableForm.validate()
    },
    async handleAdd() {
      this.$emit('input', [...this.value, { ...objData }])
    },
    getGiftsListChange(row, value) {
      console.log('图片', value)
      if (value.length > 7) {
        this.$message.error('最多上传7张图片')
        return
      }
      row.giftsImgList = [...value]
    },
    handleDelete(index) {
      if (this.value.length === 1) {
        this.$message.error('至少保留一条数据')
        return
      }
      const dataList = [...this.value]
      dataList.splice(index, 1)
      this.$emit('input', dataList)
    },
    async querySearch(queryString, cb) {
      try {
        const { data } = await materialGifts(queryString)
        const items = data.map(i => {
          return {
            ...i,
            value: i.giftsCode
          }
        })
        cb(items)
      } catch (e) {
        cb([])
      }
    },
    handleSelectGiftsCode(item, row) {
      row.giftsImgList = []
      row.giftsCode = item.value
      row.giftsName = item.giftsName
      row.giftsNum = item.giftsNum
      row.policyType = item.policyType
      const giftsLargeImg = item.giftsLargeImg?.split(',') ?? []
      const giftsMediumImg = item.giftsMediumImg?.split(',') ?? []
      const giftsSmallImg = item.giftsSmallImg?.split(',') ?? []
      const giftsImg = item.giftsImg?.split(',') ?? []
      giftsImg.forEach((i, index) => {
        row.giftsImgList.push({
          big: giftsLargeImg[index],
          centre: giftsMediumImg[index],
          small: giftsSmallImg[index],
          materialUrl: i
        })
      })
      if (this.value.length === 1) {
        this.$emit('changeGiftsCode', item)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.giftList::v-deep {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #fafafa;
  padding-bottom: 5px;
  margin-bottom: 10px;
  .el-table--mini .el-table__cell {
    padding: 15px 0;
  }
  .el-table tr {
    background-color: #fafafa;
  }
  .el-input-number {
    max-width: 110px;
  }
  .addBtn {
    // position: absolute;
    right: 5px;
    top: 0;
    margin-left: 10px;
    margin-top: 5px;
  }
  .el-table th.el-table__cell {
    background-color: #f5f7fa;
  }
  .tips {
    display: none;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .image-upload-container {
    display: flex;
    align-items: center;
    height: 40px;
    min-height: 40px !important;
    .image_poster {
      width: 40px !important;
      height: 40px !important;
      > span {
        display: none;
      }
    }
    .upload-delete {
      top: 0;
      right: 0;
    }
    .upload-items {
      display: flex;
      align-items: center;
    }
    .draggle {
      // transform: scale(0.2);
      width: 40px;
      height: 40px;
      margin-bottom: 0;
    }
  }
}
</style>
